(() => {
  const storefrontOrigin = 'https://florisvanlaren.nl';
  const internalHosts = new Set(['florisvanlaren.nl', 'www.florisvanlaren.nl', 'v8u3xh-zz.myshopify.com']);
  function normalizeLink(anchor) {
    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#') || /^(mailto:|tel:|javascript:|data:)/i.test(href)) return;
    let destination;
    try { destination = new URL(href, window.location.href); } catch { return; }
    if (!internalHosts.has(destination.hostname) || !/^https?:$/.test(destination.protocol)) return;
    const normalized = storefrontOrigin + destination.pathname + destination.search + destination.hash;
    if (href !== normalized) anchor.setAttribute('href', normalized);
  }
  function normalizeTree(root) {
    if (!(root instanceof Element) && root !== document) return;
    if (root instanceof Element && root.matches('a[href]')) normalizeLink(root);
    root.querySelectorAll('a[href]').forEach(normalizeLink);
  }
  function start() {
    normalizeTree(document);
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'attributes') normalizeLink(record.target);
        else record.addedNodes.forEach(normalizeTree);
      });
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
